<template>
  <v-dialog :width="formWidth" v-model="visible" @keydown.esc="cancel">
    <v-card>
      <v-card-text class="pa-4">
        <FormControl ref="theForm" v-model="value" :schema="schema" />
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click.native="cancel">Cancel</v-btn>
        <v-btn color="primary" text @click.native="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 * 
 * See https://gist.github.com/eolant/ba0f8a5c9135d1a146e1db575276177d
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
import FormControl from '@/forms/FormControl'

export default {

  components: {
    FormControl,
  },
  data: () => ({
    value: null,
    schema: null,
    visible: false,
    resolve: null,
    reject: null,
  }),

  computed: {
    formWidth() {
      if(!this.schema)
        return 650
        
      return this.schema.width || 650
    }
  },

  methods: {

    open(value, schema) {
      this.schema = schema
      this.value = value
      this.visible = true
      setTimeout( () => {
        this.$refs.theForm.focusFirst()
      },400)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })

    },

    cancel() {
      this.resolve(false)
      this.visible = false
    },

    save() {
      this.resolve(this.value)
      this.visible = false
    },

  }
}
</script>


// WEBPACK FOOTER //
// FormDialog.vue?180ce914